import "pixi.js";
import BaseComponent from "./BaseComponent";
import C_Entity from "../../const/C_Entity";
import Physics from "./Physics";
import GameSprite from "./GameSprite";
import Point3D from "../math/Point3D";
import Entity from "../components/Entity";
import MathUtil from "../utils/MathUtil";


class AsteroidSpawner extends BaseComponent
{


    constructor()
    {
        super();
        this.app = PIXI.app;
        this.entitySystem = this.app.controller.eSys;
        this.timeToNext = 0;
    }


    update(delta)
    {
        this.timeToNext -= delta;

        if (this.timeToNext <= 0)
        {
            //this.timeToNext = .1;
            this.spawnAsteroid();
        }

    }


    spawnAsteroid()
    {
        let e = new Entity(C_Entity.ASTEROID);

        let p = new Physics();

        let r = 8 + Math.random() * 25;
        let theta = Math.random() * Math.PI * 2;

        let startPt = MathUtil.polarToRectangular(r, theta);

        let startX = startPt.x;
        let startY = startPt.y;
        let startZ = 1500;

        this.spawnPt = new Point3D(startX, startY, startZ);

        p.setPosition(this.spawnPt.x, this.spawnPt.y, this.spawnPt.z);
        p.setVelocity(0,0,-600 + Math.random()*-100);
        p.setSize(.2 + Math.random()*.2);

        let s = new GameSprite("asteroid_" + MathUtil.getRandomInt(1,2));
        s.fadeInTime = .1;
        //TweenMax.to(s.sprite, this.rotationDur, {rotation:this.waveRotation, delay:this.rotationDelay});

        e.addComponent(p);
        e.addComponent(s);

        this.entitySystem.addEntity(e);
    }


}


export default AsteroidSpawner;